<template>
  <section class="body">
    <div
      v-if="toplistInitStatus == 'LOADING'"
      class="text-center mb-2"
    >
      <b-progress
        :value="loadingFormDataValue"
        show-progress
        class="m-5"
      />
    </div>
    <div
      v-if="toplistInitStatus == 'FAILED'"
      class="failedRequest"
    >
      Kan ej returnera resultat pga ett serverfel.
    </div>
    <div v-if="toplistInitStatus == 'LOADED'">
      <b-form class="formclass">
        <div class="d-flex justify-content-center align-items-center">
          <button
            type="button"
            class="btn btnclass smallerfontsize selected mr-3"
            @click="form.date.showDateModal = true"
          >
            Datum
          </button>
          <b-modal
            v-model="form.date.showDateModal"
            :no-close-on-backdrop="true"
            body-class="d-flex align-items-center"
            title="Datum"
            @shown="datePopupIsShown"
            @ok="saveDate"
          >
            <div class="viewmode">
              <label class="label-text">
                Visningsläge
              </label>
              <div class="input-group">
                <v-select
                  v-model="groupByValue"
                  :searchable="false"
                  :clearable="false"
                  class="w-100"
                  :options="groupByOptions"
                />
              </div>
            </div>
            <div
              v-if="groupByValue.id === 'day'"
              class="samewidth"
            >
              <label class="label-text w-100">
                Dag
              </label>
              <date-picker
                ref="datepickerDay"
                v-model="tempDay"
                :show-week-number="true"
                value-type="format"
                :disabled-date="disabledRangeDay"
                :clearable="false"
              />
            </div>
            <div
              v-else
              class="samewidth d-flex"
            >
              <div class="col-12 d-inline-block px-0">
                <label class="label-text w-100">
                  Vecka
                </label>
                <date-picker
                  ref="datepickerWeek"
                  v-model="tempWeekAndYear"
                  type="week"
                  :disabled-date="disabledRangeWeek"
                  :clearable="false"
                />
              </div>
            </div>
            <template #modal-footer="{ cancel, ok }">
              <b-button
                size="sm"
                variant="outline-secondary"
                @click="cancel()"
              >
                Avbryt
              </b-button>
              <b-button
                size="sm"
                variant="primary"
                @click="ok()"
              >
                Spara
              </b-button>
            </template>
          </b-modal>
          <SiteModal :form="form" />
          <CheckboxDropdownCategories
            id="categories-select"
            ref="categoriesDropdown"
            :form-field="form.categories"
            name="Kategorier"
            @input="updateCategoryIds"
          />
        </div>
      </b-form>
      <b-form-row class="d-flex justify-content-center align-items-center mt-2">
        <button
          class="trashbtn mt-2 mr-2"
          @click="clearAllFields"
        >
          <b-icon-trash />
        </button>
        <div
          v-for="(selectedButton, key) in selectedBtns"
          :key="key"
          class="d-flex justify-content-center"
        >
          <button
            class="selectedbtns mr-2 mt-2 bubblefontsize"
            @click="selectedButton.clickedBtn && selectedButton.clickedBtn()"
          >
            <span v-html="selectedButton.text" />
            <b-icon
              v-if="selectedButton.editable"
              class="ml-2 crossbtn"
              font-scale="1.5"
              icon="x"
              @click="
                selectedButton.clickedBtnDelete &&
                  selectedButton.clickedBtnDelete($event)
              "
            />
          </button>
        </div>
      </b-form-row>
      <b-form-row class="mb-2 mt-3">
        <b-col
          class="justify-content-end d-flex align-items-end"
          cols="12"
        >
          <b-button
            type="submit"
            class="float-right searchbutton ml-2 "
            variant="primary"
            size="sm"
            :disabled="disableRunBtn"
            @click="submitSearch"
          >
            <b-icon
              v-if="!loadingSearchResults"
              icon="arrow-repeat"
            />
            {{ loadingSearchResults ? 'Arbetar...' : 'Kör' }}
          </b-button>
        </b-col>
      </b-form-row>
      <section>
        <div
          v-if="loadingSearchResults"
          class="text-center mb-2"
        >
          <hr>
          <b-spinner
            variant="primary"
            type="grow"
            label="Spinning"
          />
          <div>
            <small class="text-muted">Laddar resultat...</small>
          </div>
        </div>
        <div v-else-if="showResultTable">
          <hr>
          <b-tabs
            small
            content-class="mt-3"
          >
            <b-tab
              ref="listTab"
              title="Lista"
              active
            >
              <b-table
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                striped
                small
                :fields="fields"
                :items="results.columnData"
                :head-variant="'dark'"
              >
                <template v-slot:cell(measure_1)="data">
                  {{ formatNumber(data.value) }}
                </template>
              </b-table>
            </b-tab>
          </b-tabs>
        </div>
        <div
          v-else-if="showNoSearchResultText"
          class="text-center"
        >
          <hr>
          <p>Inget sökresultat</p>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import SiteModal from '@/components/Shared/SiteModal';
import CheckboxDropdownCategories from '../../Shared/CheckboxDropdownCategories.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/sv';
import * as api from '@/assets/js/api';
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';
import dayjs from 'dayjs';
import {
  arrayToCsv,
  downloadBlob,
  isDateNotBetweenTwoDates,
  sleep,

} from '../../../assets/js/utils';
export default {
  name: 'Toplist',
  components: {
    SiteModal,
    CheckboxDropdownCategories,
    DatePicker,
    vSelect,
  },
  data() {
    return {
      calledSubmit: 0,
      tempDay: "",
      tempWeekAndYear: "",
      loadingFormDataValue: 0,
      defaultPublishedDate: '',
      getter: 'getToplistQuery',
      setter: 'setToplistQuery',
      toplistInitStatus: 'LOADING',
      groupByValue: { label: 'Dag', id: 'day' },
      groupByOptions: [
        { label: 'Dag', id: 'day' },
        { label: 'Vecka', id: 'week' },
      ],
      loadingSearchResults: false,  
      sortBy: 'measure_1',
      sortDesc: true,
      form: {       
        date: {
          showDateModal: false
        },
        sites: {
          options: [],
          selected: [],
          apiBodyGetter: 'getToplistQuery',
          apiBodySetter: 'setToplistQuery',
          showSiteModal: false
        },
        categories: {
          options: [],
          selected: []
        },
        columns: {
          options: [
            {
              key: 'published_at',
              sortable: true,
              sortDirection: 'desc',
              label: 'Publicerat',
            },
            {
              key: 'site_name',
              sortable: true,
              sortDirection: 'desc',
              label: 'Site',
            },
            {
              key: 'title',
              sortable: true,
              sortDirection: 'desc',
              label: 'Titel',
            },
            {
              key: 'episode_number',
              sortable: true,
              sortDirection: 'desc',
              label: 'Episod',
            },
            {
              key: 'season_number',
              sortable: true,
              sortDirection: 'desc',
              label: 'Säsong',
            },
            {
              key: 'title_length_formatted',
              sortable: true,
              sortDirection: 'desc',
              label: 'Längd',
            },
            {
              key: 'category_name',
              sortable: true,
              sortDirection: 'desc',
              label: 'Kategori',
            },
          ],
        },
      },
      selectedBtns: []
    };
  },
  computed: {
    payload(){
      return this.$store.getters.getToplistQuery
    },
    allModalsClosed() {
      let allModalsClosed = false;
      if (
        !this.form.date.showDateModal &&
        !this.form.sites.showSiteModal
      )
        allModalsClosed = true;
      return allModalsClosed;
    },
    showResultTable() {
      if (this.results.status === 'NOT_LOADED' || this.results.columnData.length === 0) return false;
      return true;
    },
    showNoSearchResultText() {
      let showNoSearchResultText = false;
      if (this.results.status === 'NOT_LOADED') return showNoSearchResultText;
      else if (this.results.columnData.length === 0) showNoSearchResultText = true;
      return showNoSearchResultText;
    },
    columnPickerLabel() {
      let NumberOf = this.$store.getters.getToplistQuery.columns.length;
      return NumberOf != 1 ? ` Kolumner (${NumberOf} valda)` : ` Kolumner (${NumberOf} vald)`;
    },
    columns: {
      get() {
        return this.$store.getters[this.getter]['columns'];
      },
      set(val) {
        const updatedQuery = {
          ...this.$store.getters[this.getter],
          ['columns']: val,
        };
        return this.$store.commit(this.setter, updatedQuery);
      },
    },
    fields() {
      return this.$store.getters.getToplistFields;
    },
    results() {
      return this.$store.getters.getToplistResults;
    },
     disableRunBtn() {
       let disableRunBtn = false;     
       if (this.loadingSearchResults) disableRunBtn = true;
       return disableRunBtn;
     },
    publishedToDate() {
      return this.$store.getters['systemInfo/getPublishedToDate'];
    },
  },
  watch: {
    publishedToDate(publishedToDate) {
      this.setDefaultWeekAndYear(publishedToDate);
      const updatedQuery = {
        ...this.$store.getters[this.getter],
        publishedToDate,
      };
      this.$store.commit(this.setter, updatedQuery);
    },
    payload: {
      handler() {
        let query = this.$store.getters.getToplistQuery;
        let selectedBtns = [];
        if(this.groupByValue.id === "day")
          selectedBtns.push(
          {
            text: `<span class="font-weight-bold">Dag:</span> ${query.start_date}`,
            editable: false,
            clickedBtn: () => {
              this.form.date.showDateModal = true;
            }
          })
        else
          selectedBtns.push(
          {
            text: `<span class="font-weight-bold">Vecka:</span> ${this.getWeekFromDate(query.start_date)}`,
            editable: false,
            clickedBtn: () => {
              this.form.date.showDateModal = true;
            }
          })
        if (query.site_id) {
          let chosenText = query.site_id.length > 1 ? "valda" : "vald";
          selectedBtns.push({
            text: `<span class="font-weight-bold">Site:</span> (${query.site_id.length} ${chosenText})`,
            clickedBtn: () => {
              this.form.sites.showSiteModal = true;
            }
          });
        }
        if (query.category_id.length > 0) {
          let chosenCategories = this.form.categories.options.filter(c => query.category_id.includes(c.value)).map(c => c.text)
          selectedBtns.push({
            text: `<span class="font-weight-bold">Kategorier:</span> ${chosenCategories.join(', ')}`,
            editable: true,
            clickedBtnDelete: event => {
              event.stopPropagation();
              query.category_id = []
              this.form.categories.selected = []
            }
          });
        }
        this.selectedBtns = selectedBtns;
      },
      deep: true
    },
  },
  beforeDestroy() {
    // Clean up by removing the event listener when the component is destroyed
    document.removeEventListener("keyup", this.onKeyUp);
  },
  async mounted() {
    if (!this.$store.state.systemInfo.fullAccess && !this.$store.state.systemInfo.lightAccess) {
      this.$router.push('/');
    }
    this.defaultPublishedDate = this.publishedToDate;
    this.$store.commit('systemInfo/updateAnyFormFieldsLoaded', true);
    document.addEventListener("keyup", this.onKeyUp);
  },
  async created() {
    if (this.publishedToDate) {
      this.setDefaultWeekAndYear(this.publishedToDate);
      const updatedQuery = {
        ...this.$store.getters[this.getter],
        publishedToDate: this.publishedToDate,
        start_date: this.publishedToDate,
        end_date: this.publishedToDate
      };
      this.$store.commit(this.setter, updatedQuery);
    }
    let sitesResponse = await api.fetchFormFieldData('Sites', 'Program');
    if (sitesResponse.statusCode) {
      this.$bvToast.toast(sitesResponse.errorMessage, {
        title: 'Varning',
        variant: 'warning',
        solid: true,
        autoHideDelay: 3000,
      });
    } else {
      for (let index in sitesResponse) {
        let site = {
          text: sitesResponse[index].site_name,
          value: sitesResponse[index].site_id,
          selected: true,
        };
        this.form.sites.options.push(site);
      }
    }
    let siteValues = this.form.sites.options.map(s => s.value)
    this.updateSiteIds(siteValues);
    this.loadingFormDataValue = 50;
    //Fetch categories from api
    let categoriesResponse = await api.fetchFormFieldData('Categories');
    if (categoriesResponse.statusCode) {
      this.$bvToast.toast(categoriesResponse.errorMessage, {
        title: 'Varning',
        variant: 'warning',
        solid: true,
        autoHideDelay: 3000,
      });
    } else {
      for (let index in categoriesResponse) {
        let category = {
          text: categoriesResponse[index].category_name,
          value: categoriesResponse[index].category_id,
        };
        this.form.categories.options.push(category);
      }
      this.loadingFormDataValue = 100;
    }
    await sleep(600);
    this.toplistInitStatus = 'LOADED';
    this.setDefaultSavedMeasure();
    if (this.results.status === 'NOT_LOADED') 
    {
      this.$nextTick(() => {
        setTimeout(this.submitSearch, 1000);
      })
    }
  },
  methods: {
    datePopupIsShown() {
      let toplistQuery = { ...this.$store.getters.getToplistQuery };
      let subtractWeeks = 0;
      if(toplistQuery.start_date === toplistQuery.publishedToDate)
        subtractWeeks = 1;

      let newWeek = dayjs(toplistQuery.start_date).subtract(subtractWeeks, 'week').format('YYYY-MM-DD');
      this.tempWeekAndYear = new Date(newWeek)
      this.tempDay = toplistQuery.start_date;
      if (this.groupByValue.id === "day") {
        setTimeout(() => {
          this.$refs.datepickerDay.focus();
        }, "100");
      } else {
        setTimeout(() => {
          this.$refs.datepickerWeek.focus();
        }, "100");
      }
    },
    saveDate() {
      let toplistQuery = { ...this.$store.getters.getToplistQuery };
      if(this.groupByValue.id === "day"){
        toplistQuery.start_date = this.tempDay;
        toplistQuery.end_date = this.tempDay;
      }
      else{
        toplistQuery = {
          ...toplistQuery,
          ...this.getWeekStartEndDateObj()
        }
      }
      this.$store.commit("setToplistQuery", toplistQuery);
    },
    clearAllFields()
    {
      this.groupByValue = { label: 'Dag', id: 'day' }
      this.changedGroupBy(this.groupByValue);
      this.setDefaultWeekAndYear(this.defaultPublishedDate);
      let siteValues = this.form.sites.options.map(s => s.value)
      this.updateSiteIds(siteValues);
      let toplistQuery = {
        ...this.$store.getters.getToplistQuery,
        category_id: []
      }
      this.$store.commit("setToplistQuery", toplistQuery);
      this.form.categories.selected = []
    },
    formatNumber(number) {
      if (number === null) return;
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    updateSiteIds(siteIds) {
      this.$store.commit('setToplistQuery', {
        ...this.$store.getters.getToplistQuery,
        site_id: siteIds
      });    
    },
    updateCategoryIds(categoryIds) {
      this.$store.commit('setToplistQuery', {
        ...this.$store.getters.getToplistQuery,
        category_id: categoryIds
      });      
    },
    changedGroupBy(groupBy) {
      let query = {
        ...this.$store.getters[this.getter],
      };
      if (groupBy.id === 'week') {
        query = { ...query, ...this.getWeekStartEndDateObj() };
      } else {
        query = { ...query, start_date: this.defaultPublishedDate, end_date: this.defaultPublishedDate };
      }
      this.$store.commit('setToplistQuery', query);
    },
    getWeekStartEndDateObj() {
      let weekAndYear = new Date(this.tempWeekAndYear);
      const offset = weekAndYear.getTimezoneOffset();
      weekAndYear = new Date(weekAndYear.getTime() - offset * 60 * 1000);
      let weekAndYearString = weekAndYear.toISOString().split('T')[0];
      let weekday = require('dayjs/plugin/weekday');
      dayjs.extend(weekday);
      require('dayjs/locale/sv');
      let startDate = dayjs(weekAndYearString)
        .locale('sv')
        .weekday(0)
        .format('YYYY-MM-DD');
      let endDate = dayjs(weekAndYearString)
        .locale('sv')
        .weekday(6)
        .format('YYYY-MM-DD');
      return {
        start_date: startDate,
        end_date: endDate,
      };
    },
    setDefaultSavedMeasure() {
      let measure = {
        consolidation_days: -1,
        isReach: false,
        measure_name: 'Rating indv A3-99 KO vald period',
        measure_type: 'rating',
        target_group_keys: this.getTargetGroupKeys(),
        min_viewing_time: 0,
      };
      let toplistQuery = { ...this.$store.getters.getToplistQuery, measures: [{ ...measure }] };
      this.$store.commit('setToplistQuery', toplistQuery);
    },
    getTargetGroupKeys() {
      return [
        'female_age14',
        'male_age14',
        'female_age19',
        'male_age19',
        'female_age24',
        'male_age24',
        'female_age29',
        'male_age29',
        'female_age44',
        'male_age44',
        'female_age49',
        'male_age49',
        'female_age59',
        'male_age59',
        'female_age64',
        'male_age64',
        'female_age99',
        'male_age99',
      ];
    },
    disabledRangeDay(datepickerDate) {
      let startDate = new Date(this.$store.getters['systemInfo/getPublishedFromDate']);
      let endDate = new Date(this.$store.getters['systemInfo/getPublishedToDate']);
      let disableDate = isDateNotBetweenTwoDates(datepickerDate, startDate, endDate);
      return disableDate;
    },
    disabledRangeWeek(datepickerDate) {
      let startDate = new Date(this.$store.getters['systemInfo/getPublishedFromDate']);
      let endDate = new Date(this.$store.getters['systemInfo/getPublishedToDate']);
      if (startDate.getDay() !== 1) {
        let weekday = require('dayjs/plugin/weekday');
        dayjs.extend(weekday);
        require('dayjs/locale/sv');
        dayjs.locale('sv');
        startDate = new Date(
          dayjs(this.$store.getters['systemInfo/getPublishedFromDate'])
            .weekday(7)
            .format('YYYY-MM-DD'),
        );
      }
      if (endDate.getDay() !== 0) {
        endDate = new Date(
          dayjs(this.$store.getters['systemInfo/getPublishedToDate'])
            .day(-0)
            .format('YYYY-MM-DD'),
        );
      }
      let disableDate = isDateNotBetweenTwoDates(datepickerDate, startDate, endDate);
      return disableDate;
    },
    sortChanged(sortInfo) {
      let sortAsMeasure = false;
      if (sortInfo.sortBy.includes('measure')) sortAsMeasure = true;
      if (sortAsMeasure && sortInfo.sortDesc) {
        this.results.sort((a, b) => {
          let sortByA = a[sortInfo.sortBy].replace(/ /g, '');
          let sortByB = b[sortInfo.sortBy].replace(/ /g, '');
          if (sortByB == '') return -1;
          if (typeof a[sortInfo.sortBy] === 'string')
            sortByA = parseFloat(a[sortInfo.sortBy].replace(/,/g, '.').replace(/\s/g, ''));
          if (typeof b[sortInfo.sortBy] === 'string')
            sortByB = parseFloat(b[sortInfo.sortBy].replace(/,/g, '.').replace(/\s/g, ''));
          return sortByB - sortByA;
        });
      } else if (sortAsMeasure && !sortInfo.sortDesc) {
        this.results.sort((a, b) => {
          let sortByA = a[sortInfo.sortBy].replace(/ /g, '');
          let sortByB = b[sortInfo.sortBy].replace(/ /g, '');
          if (sortByA == '') return -1;
          if (typeof a[sortInfo.sortBy] === 'string')
            sortByA = parseFloat(a[sortInfo.sortBy].replace(/,/g, '.').replace(/\s/g, ''));
          if (typeof b[sortInfo.sortBy] === 'string')
            sortByB = parseFloat(b[sortInfo.sortBy].replace(/,/g, '.').replace(/\s/g, ''));
          return sortByA - sortByB;
        });
      } else this.results.sort(this.dynamicSort(sortInfo));
      this.sortBy = sortInfo.sortBy;
      this.sortDesc = sortInfo.sortDesc;
    },
    dynamicSort(sortInfo) {
      let sortOrder = 1;
      if (sortInfo.sortDesc) sortOrder = -1;
      return function(a, b) {
        let result =
          a[sortInfo.sortBy] < b[sortInfo.sortBy]
            ? -1
            : a[sortInfo.sortBy] > b[sortInfo.sortBy]
            ? 1
            : 0;
        return result * sortOrder;
      };
    },
    getWeekFromDate(date) {
      let weekAndYear = new Date(date);
      const offset = weekAndYear.getTimezoneOffset();
      weekAndYear = new Date(weekAndYear.getTime() - (offset * 60 * 1000));
      let isoWeek = require('dayjs/plugin/isoWeek');
      dayjs.extend(isoWeek);
      return dayjs(weekAndYear.toISOString().split('T')[0]).isoWeek();
    },
    setDefaultWeekAndYear(programToDate) {
      let defaultWeek = new Date(programToDate);
      if (defaultWeek.getDay() !== 0) {
        defaultWeek.setDate(defaultWeek.getDate() - 7);
      }
      this.tempWeekAndYear = defaultWeek;
    },
    async submitSearch() {
      this.calledSubmit++;
      try {
        if(this.calledSubmit !== 1 || this.$store.getters["systemInfo/getActiveTab"] !== "Toplist")
          return;
        this.calledSubmit = 0
        this.loadingSearchResults = true;
        this.sortBy = 'measure_1';
        this.sortDesc = true;
        this.loadingSearchResults = true;

        let queryPayload = {
          payload: {
            ...this.$store.getters.getToplistQuery,
            selected_columns: this.$store.getters.getToplistQuery.columns
          },
          sort_by:this.$store.getters.getToplistQuery.sort_by,
          sort_direction:this.$store.getters.getToplistQuery.sort_direction,
        };

        const result = await api.search('ProgramLight/Toplist', queryPayload);
        let toplistFields = [...this.form.columns.options];
        let numberOfMeasures = this.$store.getters.getToplistQuery.measures.length;
        if (this.groupByValue.id === 'week')
          toplistFields.unshift({ key: 'week', label: 'Nr.', sortable: true });
        else toplistFields.unshift({ key: 'date', label: 'Nr.', sortable: true });

        for (let i = 0; i < numberOfMeasures; i++) {
          let measure = this.$store.getters.getToplistQuery.measures[i];
          toplistFields.push({
            key: `measure_${i + 1}`,
            sortable: true,
            sortDirection: 'desc',
            label: measure.measure_name,
          });
        }

        this.$store.commit('setToplistFields', toplistFields);

        for (let indexRow = 0; indexRow < result.columnData.length; indexRow++) {
          if (this.groupByValue.id === 'week') result.columnData[indexRow].week = indexRow + 1;
          else result.columnData[indexRow].date = indexRow + 1;
          for (let indexMeasure = 0; indexMeasure < numberOfMeasures; indexMeasure++) {
            result.columnData[indexRow][`measure_${indexMeasure + 1}`] = 
              result.measureData[indexRow].formatted_measures[indexMeasure];
          }
        }
        this.$store.commit('setToplistResult', result);
        this.loadingSearchResults = false;
      } catch {
        this.loadingSearchResults = false;
        this.$bvToast.toast('Okänt serverfel vid hämtning av resultat', {
          title: 'Fel',
          variant: 'danger',
          solid: true,
          autoHideDelay: 10000,
        });
      }
    },
    getColumns(query, withNewline = true) {
      let columnsForTable = query.columns.map((c) => ({
        column_type: c.column_type,
        key: c.display_name,
        label: c.display_name,
        sortable: true,
      }));
      let measuresForTable = query.measures.map((m, i) => ({
        column_type: m.measure.column_type,
        key: `measure_${i + 1}`,
        label: this.stringifyTarget(m, withNewline),
        labelWithoutNewline: this.stringifyTarget(m, false),
        sortable: true,
        tdAttr: {
          style: 'text-align:right',
        },
        tdClass: 'tdSummaryDataClass',
        thClass: 'measure-header',
      }));
      return [...columnsForTable.concat(measuresForTable)];
    },
    async exportResult() {
      try {
        let columns = this.getColumns(this.$store.getters.getToplistQueryResult, false);
        let columnLabels = columns.map((c) => c.label);
        let columnKeys = columns.map((c) => c.key);
        let rows = [];
        for (let iRows = 0; iRows < this.results.length; iRows++) {
          let row = [];
          for (let iCol = 0; iCol < columnKeys.length; iCol++) {
            let rowValue = this.results[iRows][columnKeys[iCol]] ?? '';
            row.push(rowValue);
          }
          rows.push(row);
        }
        let csv = arrayToCsv([columnLabels, ...rows]);
        downloadBlob(
          csv,
          `TV-Analys_Toplist_${new Date().toISOString().split('T')[0]}.csv`,
          'text/csv;charset=utf-8;',
        );
      } catch (error) {
        this.$bvToast.toast('Det gick inte att exportera', {
          title: 'Serverfel',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
        return;
      }
    },
    onKeyUp(event) {
      event.preventDefault(); // Prevent default behavior
      if (event.key === "Enter" && this.form.date.showDateModal) {
        this.form.date.showDateModal = false;
        this.saveDate();
      }
      else if (event.key === "Enter" && this.allModalsClosed && !this.loadingSearchResults) {
        this.submitSearch();
      }
    }, 
  },
};
</script>
<style>
.mx-calendar-week-mode .mx-week-number {
  font-weight: bold;
  background: #337ab7;
  color: white;
  border: 1px solid #ffffff;
}
.mx-btn-current-month,
.mx-btn-current-year {
  float: none;
}
</style>
<style scoped>
>>> .viewmode {
    display: inline-grid;
    margin-right: 1rem;
}
.addedmeasures {
  padding: 0.75rem 1.25rem;
}
.form-selects label {
  width: 100%;
}
.mx-datepicker {
  float: left;
  width: 100%;
}
.input-group {
  font-size: 0.875rem;
}
>>> .measure-header {
  white-space: pre-line;
}
>>> .input-group {
  font-size: 0.875rem;
  width: 6rem;
}
</style>
